import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Button, Segment } from "semantic-ui-react";

import SegmentMessage from "../forms/messages/SegmentMessage.jsx";

import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class ReadOnlyDependencyMessage extends Component {
  static propTypes = {
    messageCopyKey: PropTypes.string.isRequired,
    actionsCopyKey: PropTypes.string.isRequired,
    onCancel: PropTypes.func.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    actionsCopyKey: "project_wizard.actions_panel"
  };

  render() {
    const { messageCopyKey, actionsCopyKey, onCancel, copy } = this.props;

    return (
      <Fragment>
        <SegmentMessage
          title={copy(`${messageCopyKey}.title`)}
          message={copy(`${messageCopyKey}.message`)}
          negative={true}
          style={{ marginTop: "2em" }}
        />
        <Segment basic textAlign="right" style={{ paddingRight: "0px" }}>
          <Button type="button" onClick={onCancel}>
            {copy(`${actionsCopyKey}.cancel`)}
          </Button>
        </Segment>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(ReadOnlyDependencyMessage);
